module.exports = __webpack_public_path__ + "img/bh_20.64e15f61.jpg";